var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgUp = function SvgUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.71 15.96c0 .2-.07.38-.22.53-.3.3-.78.3-1.08 0l-7.7-7.4-7.69 7.4c-.3.3-.79.3-1.08 0a.74.74 0 010-1.06l8.23-7.93a.78.78 0 011.08 0l8.23 7.93c.16.14.23.34.23.53"
  })));
};
export default SvgUp;